<template>
  <div id="signup">
    
    <!-- Prev Button -->
    <router-link to="/login" class="prev-btn">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
    </router-link>
    
    <div class="infor-box">
    <!-- infor-box -->
      <h2>로그인</h2>
      <p>반갑습니다. 홍길동님! </p>

      <div class="user-box">
        <img src="../assets/images/user.png" alt="User Image">
      </div>
    </div>
    
    <!-- Form -->
    <form action="">
      <div class="form-group">
        <label for="input_id">아이디  또는 이메일</label>
        <input type="text" name="id" id="input_id" v-model="id">
      </div>
      <div class="form-group">
        <label for="input_pw">비밀번호</label>
        <input type="password" name="pw" id="input_pw" v-model="pw"><!-- 사용자가 입력받은 값이 일치하는지 체크해야하는 -->
      </div>
      <p>
        <a href="#" class="btn btn2" v-on:click="loginSuccess">로 그 인</a>
      </p>
    </form>


    <!-- Bar-box -->
    <div class="bar-box">
      <p><a href="#">ID => "text" PW => "1234" 입니다~</a></p>

      <div class="bar">

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Signup",
  data(){
    return{
      id:'', // this.id
      pw:''  // this.pw
    };
  },
  mounted(){
    this.loginSuccess();
  },  
  methods: {
    loginSuccess(){
      var inputId = this.id;
      var inputPw = this.pw;
      if(inputId === 'test' && inputPw === '1234'){ // 하...
        this.$router.push('/home');
      }else{
        this.$router.push('/signup');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../sass/partials/mixin", "../sass/partials/variable";

  #signup{
    padding-top: 30px;

    // Prev Button
    .prev-btn{
    display: inline-block;
    height: 40px;
    color : #fff;
    font-size: 2.7rem;
    margin-bottom: 30px;
  }
  // infor-box
  .infor-box{
    position: relative;
    padding: 0 20px;
    margin-bottom: 42px;
    
    h2{ 
      height: 30px;
      margin-bottom: 10px;
      @include font-set(700, 2.2rem, 30px, $ff1);
    }
    p{ 
      height: 21px;
      color : darken(#fff, 50%);
      @include font-set(normal, 1.6rem, 21px, $ff3);
    }
    .user-box{
      width: 60px;
      height: 60px;
      position: absolute; right: 20px; top: 0; 
    }
  }



  // form
  form{
    padding: 0 20px;

    .form-group{
      height: auto;
      margin-bottom: 20px;
      
      label{
        display: block;
        height: 16px;
        @include font-set(bold, 1.6rem, 16px, $ff1);
        margin-bottom: 15px;
      }

      input{
        width: 100%;
        height: 40px;
        border: 0;
        border-bottom: 1px solid #707070;
        background-color: transparent;
        color : #fff;
          &:focus{ background-color: transparent; }
      }
    }

    p{ margin-top: 42px; }

    }// form End
    
    // bar-box
    .bar-box{
      width: 100%;
      height: 65px;
      position: absolute; left: 0; bottom: 0;
      text-align: center;
      p a{
        color : darken(#fff, 50%);

        &:hover{ color: #fc0; }
      }
    }
  } 

  

</style>


// WEBPACK FOOTER //
// src/components/Signup.vue